import React from 'react';
import { Spread } from '../../types/spread';

interface ExpressOptionProps {
  spread: Spread;
  calculatedPrice: number;
  checked: boolean;
  onChange: (express: boolean) => void;
}

const ExpressOption: React.FC<ExpressOptionProps> = ({
  spread,
  calculatedPrice,
  checked,
  onChange,
}) => (
  <div className="form-check form-control-lg">
    <input
      className="form-check-input border-primary"
      type="checkbox"
      id="formCheck-1"
      onChange={(e) => onChange(e.target.checked)}
    />
    <label className="form-check-label" htmlFor="formCheck-1">
      Желая експресна поръчка <b>(до 24 часа)</b>
    </label>
    {checked && (
      <p className="text-muted fs-6">
        + {(spread.price / 2).toFixed(2)} EUR. Обща сума на поръчката:{' '}
        {calculatedPrice} EUR.
      </p>
    )}
  </div>
);

export default ExpressOption;
